

const dimensions = {

	'square': {
		'label': 'Square Canvas (1:1)',
		'description': `Classic Brush Ninja, great for Instagram.`,
		'size': [ 512, 512 ],
	},
	'comic': {
		'label': 'Comic Maker Page',
		'description': `Make images that can be used in the Brush Ninja Comic Maker.`,
		'size': [ 210 * 2, 287 * 2 ],
	},
	'traditional': {
		'label': 'Traditional TV (4:3)',
		'description': `For that retro tv look. Works well on Twitter and Facebook.`,
		'size': [ 600, 450 ],
	},
	'widescreen': {
		'label': 'Widescreen TV (16:9)',
		'description': `For dramatic movie style creations.`,
		'size': [ 700, 390 ],
	},
	'cinema': {
		'label': 'Cinema',
		'description': `Half the size of an HD resolution - 1920x1080`,
		'size': [ 960, 540 ],
	},

};
